import { computed, inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import type { UserClaims } from '../services/user';
import { LocalStore } from '../store/local';
import { MOCK_USER_KEY } from './mock-user.const';

@Injectable()
export class MockUserService {
  private readonly localStore: LocalStore = inject(LocalStore);

  private readonly claims: WritableSignal<UserClaims | null> = signal(this.readClaims());

  readonly name: Signal<string> = computed((): string => this.claims()?.name ?? '');

  readonly jobTitle: Signal<string> = computed((): string => this.claims()?.jobTitle ?? '');

  private readClaims(): UserClaims | null {
    const raw: string | null = this.localStore.get<string>(MOCK_USER_KEY);
    return raw === null ? null : (JSON.parse(raw) as UserClaims);
  }
}
